// 保险商城接口
import { get, post, post1 } from '../../utils/request';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 父分类
    async getReult({ commit }, insList) {

      const res = await post1('system/user/sendAccreditChat',{
        key:insList.question,
        openId:insList.openId,
        pcode1:insList.pcode1


      });
      return res;
    },
    // 上拉/system/user/sendAccreditChasystem/user/sendAccreditChattRaw
    async getPull({ commit }, insList) {
      const res = await post1('system/user/sendAccreditChatRaw',{
        openId:insList.openId,
        rawNo:insList.rawId,
        pageSize:insList.pageSize
      });
      return res;
    },

  },
};
